module.exports = __webpack_public_path__ + "img/trips-billboard.7c5aa538.jpg";